import { IPitchPerformanceFire } from 'lib_ts/interfaces/data/i-pitch-performance';
import { PitchType } from '../enums/pitches.enums';
import { IMachineState } from './i-machine-state';
import { IHasID, IMongoBase } from './mongo/_base';
import { IPlateLoc, ITrajectory, ITrajektRefBreak } from './pitches';
import { IMachineShot } from './training/i-machine-shot';

export interface IPitchPerformance extends IMongoBase {
  machineID: string;
  // yyyy-MM-dd
  date: string;
  counts: IMetricDetails;
  percents: IMetricDetails;
}

// _id will be used for checkable behaviour in table
export interface IGroupedFires extends IHasID {
  rgb: string;
  name: string;
  type: PitchType;

  target: {
    ms: IMachineState;
    traj: ITrajectory;

    speedMPH: number;
    netSpin: number;
    plate: IPlateLoc;
    break: ITrajektRefBreak;
  };

  average: {
    speedMPH: number;
    netSpin: number;
    plate: IPlateLoc;
    break: ITrajektRefBreak;
  };

  delta: {
    speedMPH: number;
    netSpin: number;
    plate: IPlateLoc;
    break: ITrajektRefBreak;
  };

  fires: IPitchPerformanceFire[];

  // aimed at the plate location of the first fire found
  rotatedShots: IMachineShot[];
}

export interface IShotActuals {
  speedMPH: number;
  break: ITrajektRefBreak;
  plate: IPlateLoc;
}

export const EMPTY_SHOT_ACTUALS: IShotActuals = {
  speedMPH: 0,
  break: {
    xInches: 0,
    zInches: 0,
  },
  plate: {
    plate_x: 0,
    plate_z: 0,
  },
};

export interface IMetricDetails {
  // should always be 100% unless there are 0 samples
  total: number;
  // cannot be higher than the minimum of the other values
  overall: number;
  // passes, not fails
  velocity: number;
  // passes, not fails
  break: number;
  // passes, not fails
  plate: number;
}

export const EMPTY_METRIC_DETAILS: IMetricDetails = {
  total: 0,
  overall: 0,
  velocity: 0,
  break: 0,
  plate: 0,
};

export interface IMetricTally {
  counts: IMetricDetails;
  percents: IMetricDetails;
}

// shown when drilling down into a pitch
export interface IFireWithMetrics extends IShotActuals, IHasID {
  target: {
    ms: IMachineState;
    traj: ITrajectory;

    speedMPH: number;
    plate: IPlateLoc;
    break: ITrajektRefBreak;
  };

  delta: {
    speedMPH: number;
    plate: IPlateLoc;
    break: ITrajektRefBreak;
  };

  shot: IMachineShot;
}

export interface IGroupedFireDict {
  [key: string]: IGroupedFires;
}
